import { Text } from '@chakra-ui/react'

export default function SectionLabel({ text, accent }) {
  return (
    <Text fontSize="xs" fontWeight="semibold" color={accent} textTransform="uppercase" letterSpacing="wide">
      {text}
    </Text>
  )
}
